import { type MutableRefObject, useCallback, useRef, useState } from 'react';

export const useRefSet = <T = string>(ini = new Set<T>()): [MutableRefObject<Set<T>>, Set<T>, (_?: Set<T>) => void] => {
  const ref = useRef(ini);
  const [set, select] = useState(ref.current);
  return [ref, set, useCallback(next => select((ref.current = new Set(next))), [select])];
};
